import { useQuery } from 'react-query';
import { api } from '../../../static/api';
import { ApiFeaturesResponse, ApiGamer, IGamer } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import useAxiosInstance from '../../axios/useAxiosInstance';

// GMT-802: columns the backend can order the whole dataset by
export type GamersOrderBy = 'email' | 'createdAt';

interface useGamersProps {
  limit: number;
  page: number;
  orderBy?: GamersOrderBy;
  sort?: 'ASC' | 'DESC';
}
const useGamers = ({ limit, page, orderBy, sort }: useGamersProps) => {
  const axiosInstance = useAxiosInstance();

  const { data, isLoading } = useQuery(
    [QueryAliases.ALL_GAMERS, limit ?? '', page ?? '', orderBy ?? '', sort ?? ''],
    () => axiosInstance.get(api.endpoints.ALL_GAMERS, { params: { limit, page, orderBy, sort } }),
    {
      refetchOnMount: true,
    },
  );

  const apiGamers: ApiFeaturesResponse<ApiGamer[]> | undefined = data?.data;

  const allGamersData: IGamer[] | undefined = apiGamers?.data?.map((gamer: ApiGamer) => ({
    ...gamer,
    userGames: gamer.userGames.length,
  }));

  const gamers = {
    count: apiGamers?.count,
    data: allGamersData,
  };

  return { gamers, isLoading };
};

export default useGamers;
